import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FiltroSqp } from '../../../sqpFiltroSuperior/models/filtro-sqp';
import { TipoFiltro } from '../../../sqpFiltroSuperior/models/tipo-filtro';

@Component({
  selector: 'app-input-buscador',
  templateUrl: './input-buscador.component.html',
  styleUrls: ['./input-buscador.component.css']
})
export class InputBuscadorComponent implements OnInit, OnDestroy {

  @Input() textoBuscar?: string = '';
  @Input() inputWidth: string = '150';
  @Output() buscador: EventEmitter<string> = new EventEmitter<string>();
  @Output() inputBuscadorEmitter: EventEmitter<FiltroSqp> = new EventEmitter<FiltroSqp>();
  @Input() limpiarTodosFiltrosSqp:number;

  private debounceTimeout: any;

  constructor() {}

  ngOnChanges(changes: SimpleChanges){
    if(changes.limpiarTodosFiltrosSqp?.currentValue>0) this.limpiarTexto();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  }

  buscar(){
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(() => {
      this.buscador.emit(this.textoBuscar);
      this.inputBuscadorEmitter.emit({
        tipoFiltro: TipoFiltro.TEXTO,
        titulo:'Buscar',
        valoresSeleccionados:{valorString:this.textoBuscar}
      });
    }, 1200);
  }

  limpiarTexto(){
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    this.textoBuscar = '';
    this.buscador.emit(this.textoBuscar);
    this.inputBuscadorEmitter.emit({
      tipoFiltro: TipoFiltro.TEXTO,
      titulo:'Buscar',
      valoresSeleccionados:{valorString:this.textoBuscar}
    });
  }
}
